import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  researchFormRequest,
  getReportRequest,
  setResetReport,
  editReportRequest,
} from '../../../redux/actions/research';
import ResearchForm from './ResearchForm';
import './ResearchForm.css';
import 'react-quill/dist/quill.snow.css';

ResearchForm.formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'video',
];

ResearchForm.modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image', 'video'],
    ['clean'],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};

ResearchForm.descriptionFormat = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
];

ResearchForm.descriptionModule = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
  ],
  clipboard: {
    matchVisual: false,
  },
};

/*
 * PropType validation
 */
ResearchForm.propTypes = {
  placeholder: PropTypes.string,
};

const mapStateToProps = state => ({
  report: state.reports.report,
});

const mapDispatchToProps = {
  researchFormRequest,
  getReportRequest,
  setResetReport,
  editReportRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResearchForm);
